import { defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import { useMediaQuery } from 'react-responsive';
import Inspector from './Inspector';
import style from './block.module.scss';

const Spacer = ({ height, laptopHeight, tabletHeight, mobileHeight }) => {
    useInspectorControl(Inspector);

    const isLaptop = useMediaQuery({
        query: '(max-width: ' + style.laptopBreakpoint + ')',
    });
    const isTablet = useMediaQuery({
        query: '(max-width: ' + style.tabletBreakpoint + ')',
    });
    const isMobile = useMediaQuery({
        query: '(max-width: ' + style.mobileBreakpoint + ')',
    });

    const spacerHeight = () => {
        if (isMobile) {
            return mobileHeight;
        } else if (isTablet) {
            return tabletHeight;
        } else if (isLaptop) {
            return laptopHeight;
        }
        return height;
    };

    return <div className={style.block} style={{ height: spacerHeight() }}></div>;
};

export default defineBlock({
    Block: Spacer,
    smartProps: {
        height: smartProps.number.withDefault(50),
        laptopHeight: smartProps.number.withDefault(45),
        tabletHeight: smartProps.number.withDefault(40),
        mobileHeight: smartProps.number.withDefault(30),
    },
    setup: {
        title: 'Spacer',
    },
});
